const mixin = {
    methods: {
        getUserInfo() {
            if (this.$store.state.token) {
                this.$request
                .post('/transformToAfter/app/user/appCurrentUser', {})
                .then((res) => {
                    this.userInfo.name = res.data.contactName
                })
            }
        },
    },
}

module.exports = {
    mixin,
}
